import { render } from "./PrivateSurvey.vue?vue&type=template&id=496bc513"
import script from "./PrivateSurvey.vue?vue&type=script&lang=js"
export * from "./PrivateSurvey.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__